import { ASTExpr } from '../lscript/ast';
import { Opaque } from '../utils/Opaque';

/*
 * Definition of a conversion between two units.  The specific units are
 * not specified here, but are instead specified in the registry.
 */
export interface Conversion {
  fromBase: (input: ASTExpr) => ASTExpr; // Conversion to the unit from the base unit
  toBase: (input: ASTExpr) => ASTExpr; // Conversion from the unit to the base unit
}

/*
 * A unit is a map from atomic units to exponents.  For example, the
 * unit "meter per second" is represented as the map
 * { meter: 1, second: -1 }.
 */
export type AtomicUnit = Opaque<string, 'AtomicUnit'>;
export type Unit = Map<AtomicUnit, number>;

/*
 * A convenience type for specifying units.  This can be either a unit string,
 * or an object with the same atomic unit/exponent pairs that will go into the map.
 */
export type UnitSpec = Record<string, number> | string;

export const UNIT_TYPES = [
  'area',
  'length',
  'mass',
  'volume',
  'time',
  'calendar',
  'fuelEconomy',
  'temperature',
  'textile',
  'energy',
  'power',
  'count',
  'currency',
  'information',
  'force',
  'carbon',
] as const;

export type UnitGroup = (typeof UNIT_TYPES)[number];
